// @ts-nocheck
import { Box, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { getStatusBadges } from "../../utils/methods/opportunity/opp";

/**
 * Shared 3-status-badge row: Approved (profile) / HR Approved (Gusto) / Roster status.
 * Single source of truth for the contractor search & assign surfaces (Send
 * Opportunity + Assign Contractor dropdown), so they look identical and future
 * tweaks live in one place. Pass the contractor object (raw doc with roles[] OR
 * the contractorDetails shape with rosterStatus — getStatusBadges handles both).
 */
export const StatusBadges = ({ cont, colWidth = 84 }) => {
  const badges = getStatusBadges(cont);
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(3, ${colWidth}px)`,
        gap: "4px",
        flexShrink: 0,
      }}
    >
      {badges.map((b, i) => (
        <Tooltip key={i} title={b.tooltip || ""} arrow placement="top">
          <Typography
            variant="span"
            sx={{
              padding: "3px 4px",
              borderRadius: "3px",
              fontWeight: "500",
              fontSize: "0.66rem",
              lineHeight: 1.4,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              background: b.backgroundColor,
              color: b.color,
              textAlign: "center",
              cursor: "default",
            }}
          >
            {b.message}
          </Typography>
        </Tooltip>
      ))}
    </Box>
  );
};

StatusBadges.propTypes = {
  cont: PropTypes.object,
  colWidth: PropTypes.number,
};

export default StatusBadges;
